/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../../components'
import { AttributeVariableForm } from '../../AttributeVariableForm'

export const AttributeVariableDialogCreate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  actionCreateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.variables.create.scenario')
    : currentProject
    ? t('attributes.variables.create.project')
    : t('attributes.variables.create.global')

  /**
   * Action received from the Variable Form.
   * @see <AttributeVariableForm />
   *
   * @param {object} newVariable Variable attribute object to update.
   * @param {string} newVariableId Variable attribute Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newVariable, newVariableId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeVariableDialogCreate.onDispatchAction()', {
      newVariable,
      newVariableId
    })

    dispatch(actionCreateDispatch(newVariable, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeVariableDialogCreate.onDispatchAction().dispatch(createProjectVariable(...)).then()',
          { res }
        )

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeVariableDialogCreate.onDispatchAction().dispatch(createProjectVariable(...)).catch()',
          { res }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        const _data = res?.response?.data || null
        if (_data && (_data?.fields || _data?.error)) {
          let _error = _data?.fields || {}
          if (_data?.error) {
            _error.generic = _data.error
          }
          setErrors(_error)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeVariableForm.render()', { currentProject, currentScenario })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeVariableForm
        title={title}
        setOpenDialogVariable={setOpenDialog}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeVariableDialogCreate.displayName = 'AttributeVariableDialogCreate'

AttributeVariableDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired
}

AttributeVariableDialogCreate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: () => {}
}
